<template>
  <div v-if="loading" class="schedule-loading">Loading...</div>
  <div v-else-if="post" class="schedule-detail">
    <img
      v-if="post.attachments"
      :src="post.attachments"
      alt="Image"
      class="image"
    />
    <img
      v-else
      src="../assets/images/dublab_default_file.png"
      alt="Image"
      class="image"
    />
    <div class="event-info">
      <div class="event-heading">
        <h2 v-if="post.title" class="event-title">
          {{ post.title.replaceAll("-", " ").trim() }}
        </h2>
        <p>{{ post.date }}</p>
        <p>{{ post.time }}</p>
      </div>
      <img
        v-if="post.attachments"
        :src="post.attachments"
        alt="Image"
        class="image mobile"
      />
      <img
        v-else
        src="../assets/images/dublab_default_file.png"
        alt="Image"
        class="image mobile"
      />
      <p class="event-copy copy" v-html="post.description"></p>
      <BoxDonate class="donate"></BoxDonate>
    </div>
  </div>
</template>

<script>
import BoxDonate from "@/components/BoxDonate";
import dayjs from "dayjs";
export default {
  name: "ScheduleDetail",
  components: {
    BoxDonate,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    post() {
      const post = this.$store.getters.getPost(this.$route.params.id)
      if (post) {
        return {
          date: dayjs(post.startTime).format("dddd MMMM DD, YYYY"),
          time: `${dayjs(post.startTime).format("hh:mm A")} to ${dayjs(
            post.endTime
          ).format("hh:mm A")}`,
          description: post.description,
          title: post.summary.split("//")[1],
          attachments: post.attachments,
        };
      }
      return null;
    }
  },
  watch: {
    post() {
      if (this.$store.getters.getPost(this.$route.params.id)) {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.$store.dispatch("getPost", this.$route.params.id);
  },
};
</script>

<style scoped>
.schedule-detail {
  display: flex;
  justify-content: flex-end;
  padding: 2rem 0;
  width: 82%;
  margin: 0 auto;
  min-height: 75vh;
}

.schedule-loading {
  min-height: 75vh;
  text-align: center;
  width: 100%;
  padding-top: 4%;
}
.event-info {
  width: 66.6%;
  padding-left: calc(5% + 1rem);
  padding-right: 5%;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.event-heading {
  text-align: center;
}

.event-title {
  font: var(--large);
  margin-bottom: 0.6rem;
  text-align: center;
}

.event-copy {
  margin-top: 2rem;
  font: var(--smallish);
}

.image {
  max-height: 65vh;
  max-width: 65vh;
}

.mobile {
  display: none;
}

.donate {
  margin-top: 4rem;
}

@media (max-width: 1000px) {
  .schedule-detail {
    width: 82%;
    padding-left: 0;
    padding-right: 0;
  }

  .image {
    display: none;
    max-width: 100%;
    max-height: 100vh;
    width: auto;
    height: auto;
    object-fit: contain;
  }

  .event-info {
    width: 100%;
    padding: 0;
  }

  .mobile {
    display: block;
    margin: 2rem auto 0;
  }
}
</style>
